import { AuthenticatedLayout } from "../components/AuthenticatedLayout";

export const PageScaffold = ({ layout, children }) => {
  const {
    accent,
    title,
    subtitle,
    icon: Icon,
    wrapContent = true,
    showHeader = true,
    contentClassName,
    outerSpacingClassName,
    isFullWidth = false,
    useCustomOuterSpacing,
  } = layout || {};

  const shouldOverrideOuterSpacing =
    typeof useCustomOuterSpacing === "boolean" ? useCustomOuterSpacing : Boolean(outerSpacingClassName);

  return (
    <AuthenticatedLayout
      contentClassName={contentClassName}
      wrapperClassName={outerSpacingClassName}
      isFullWidth={isFullWidth}
      useCustomOuterSpacing={shouldOverrideOuterSpacing}
    >
      <div className="flex flex-col gap-4">
        {showHeader && (
          <div className="flex items-center gap-4 rounded-3xl border border-white/40 bg-white/95 px-5 py-4 shadow-lg shadow-slate-900/15">
            {Icon && (
              <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-2xl bg-slate-900 text-white shadow-lg shadow-slate-900/35">
                <Icon size={24} />
              </span>
            )}
            <div className="flex flex-col gap-1">
              {accent && (
                <span className="text-xs font-semibold uppercase tracking-[0.35em] text-slate-400">
                  {accent}
                </span>
              )}
              <span className="text-xl font-semibold text-slate-900">{title}</span>
            </div>
          </div>
        )}
        {wrapContent === false ? (
          children
        ) : (
          <div className="rounded-3xl border border-white/30 bg-white/95 shadow-[0_60px_120px_-40px_rgba(15,23,42,0.75)]">
            <div className="h-full overflow-y-auto rounded-2xl bg-white/90 px-4 py-4 shadow-inner shadow-white/30">
              {children}
            </div>
          </div>
        )}
      </div>
    </AuthenticatedLayout>
  );
};
